import { fetchWithCache, getCachedData } from "../services/apiService";

export const userByIdPreview = async (user_id, { setPoster }) => {
  if (!user_id) {
    return;
  }

  const cacheKey = `/api/user/getUserByIdPreview_${user_id}`;

  // Show cached data immediately if available
  const cached = getCachedData(cacheKey, {});
  if (cached && cached[0]) {
    setPoster(cached[0]);
  }

  try {
    const data = await fetchWithCache(
      "/api/user/getUserByIdPreview",
      {
        method: "POST",
        body: JSON.stringify({ user_id }),
        cacheKey,
        retries: 2,
        timeout: 10000,
      },
      true,
    );

    if (data && data[0]) {
      setPoster(data[0]);
    }
  } catch (error) {
    if (!cached) {
      setPoster(null);
    }
  }
};

export const userById = async (user_id, { setPoster }) => {
  if (!user_id) {
    return;
  }

  const cacheKey = `/api/user/getUserById_${user_id}`;

  // Show cached data immediately if available
  const cached = getCachedData(cacheKey, {});
  if (cached && cached[0]) {
    setPoster(cached[0]);
  }

  try {
    const data = await fetchWithCache(
      "/api/user/getUserById",
      {
        method: "POST",
        body: JSON.stringify({ user_id }),
        cacheKey,
        retries: 2,
        timeout: 10000,
      },
      true,
    );

    if (data && data[0]) {
      setPoster(data[0]);
    }
  } catch (error) {
    if (!cached) {
      setPoster(null);
    }
  }
};
